import React, { useState } from "react";

/** Wrapper generic pentru drag & drop de fișiere. Highlight verde la dragover. */
export const DropZone = ({ onFiles, disabled, className = "", testId, children }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      className={`${className} ${over ? "ring-2 ring-emerald-500 ring-offset-1 bg-emerald-50/70" : ""}`}
      data-testid={testId}
      data-dragover={over ? "true" : "false"}
      onDragOver={(e) => { if (disabled) return; e.preventDefault(); e.stopPropagation(); setOver(true); }}
      onDragLeave={(e) => { e.preventDefault(); setOver(false); }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOver(false);
        if (disabled) return;
        const files = Array.from(e.dataTransfer?.files || []);
        if (files.length) onFiles(files);
      }}
    >
      {children}
    </div>
  );
};
